const actions = {
  SET_STATE: 'user/SET_STATE',
  SWITCH_PROFILE: 'user/SWITCH_PROFILE',
  LOGIN: 'user/LOGIN',
  MYOB_LOGIN: 'user/MYOB_LOGIN',
  EMAIL_LOGIN: 'user/EMAIL_LOGIN',
  FORGOT_PASSWORD: 'user/FORGOT_PASSWORD',
  REGISTER: 'user/REGISTER',
  LOAD_CURRENT_ACCOUNT: 'user/LOAD_CURRENT_ACCOUNT',
  LOGOUT: 'user/LOGOUT',
}

export default actions
